module.exports = __webpack_public_path__ + "img/1-1.98563cb5.svg";